import { Link } from 'react-router-dom'
import Logo from './Logo'
import { useAuth } from '../hooks/useAuth'

export default function Navigation() {
  const { isAuthenticated, user, logout } = useAuth()
  
  const handleLogout = async () => {
    await logout();
  }
  
  return (
    <nav className="bg-firedup-dark/95 backdrop-blur-sm border-b border-firedup-gray sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <Logo />
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link to="/" className="nav-link">
                Home
              </Link>
              {isAuthenticated && (
                <Link to="/dashboard" className="nav-link">
                  My Dashboard
                </Link>
              )}
              {user?.roles?.includes('admin') && (
                <Link to="/admin" className="nav-link">
                  Admin View
                </Link>
              )}
              {/* <Link to="/games" className="nav-link">
                Games
              </Link>
              <Link to="/locations" className="nav-link">
                Locations
              </Link> */}
            </div>
          </div>

          {/* Auth Links / User Profile */}
          {isAuthenticated ? (
            <div className="flex items-center space-x-4">
              <div className="relative group">
                <button 
                  className="flex items-center space-x-2 text-white hover:text-firedup-orange transition-colors duration-300"
                  aria-label="User menu"
                >
                  <div className="w-8 h-8 bg-gradient-to-r from-firedup-orange to-firedup-red rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-bold">
                      {user?.firstName?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <span className="hidden sm:block font-medium">{user?.displayName}</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {/* Dropdown Menu */}
                <div className="absolute right-0 mt-2 w-48 bg-firedup-gray rounded-lg shadow-lg border border-firedup-light-gray opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <div className="py-2">
                    <Link 
                      to="/dashboard" 
                      className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-firedup-light-gray transition-colors"
                    >
                      Dashboard
                    </Link>
                    {user?.roles?.includes('admin') && (
                      <Link
                        to="/admin"
                        className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-firedup-light-gray transition-colors"
                      >
                        Admin View
                      </Link>
                    )}
                    <hr className="my-2 border-firedup-light-gray" />
                    <button 
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-gray-300 hover:text-white hover:bg-firedup-light-gray transition-colors"
                    >
                      Sign Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
              <Link 
                to="/login" 
                className="nav-link hidden sm:block"
              >
                Sign In
              </Link>
            </div>
          )}

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-300 hover:text-firedup-orange focus:outline-none focus:text-firedup-orange"
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}
